import { render, staticRenderFns } from "./personal-policy-form.vue?vue&type=template&id=027dee02&scoped=true&"
import script from "./personal-policy-form.vue?vue&type=script&lang=js&"
export * from "./personal-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./personal-policy-form.vue?vue&type=style&index=0&id=027dee02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027dee02",
  null
  
)

export default component.exports